<template lang="pug">
.academy-list
  //- サイドメニュー部
  side-menu.academy-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .academy-list__content
    breadcrumb-list.academy-list__content__breadcrumb(:breadcrumbs='breadcrumbs', :buttonEvent='openRegisterModal')
      template(#buttonLabel)
        slot(name='breadcrumbButtonLabel')
    .academy-list__content__body
      .academy-list__content__body__heading
        tab-heading.academy-list__content__body__heading__tab(:isActive='true') {{ tabSetting.ACADEMY.text }}
        tab-heading.academy-list__content__body__heading__tab(
          :isActive='false',
          @click='tabHeadingEvent(tabSetting.BRANCH.value)'
        ) {{ tabSetting.BRANCH.text }}
      .academy-list__content__body__main
        .academy-list__content__body__main__action
          search-academy.academy-list__content__body__main__action__search(
            :userRole='userRole',
            :academyCode='academyCode',
            :academyName='academyName',
            :academyCodePlaceholder='academyCodePlaceholder',
            :academyNamePlaceholder='academyNamePlaceholder',
            :academyCodeChangeEvent='setAcademyCode',
            :academyNameChangeEvent='setAcademyName',
            :searchEvent='searchEvent'
          )
            template(#searchButtonText)
              slot(name='searchButtonText')
          .academy-list__content__body__main__action__button
            button-icon-circle.academy-list__content__body__main__action__button__icon(
              type='download',
              @click='downloadEvent'
            )
              slot(name='downloadIconLabel')
            button-upload.academy-list__content__body__main__action__button__icon(:uploadEvent='uploadEvent')
              template(#iconLabel)
                slot(name='uploadIconLabel')
        academy-list-table.academy-list__content__body__main__table(
          v-if='sort && academyDatas',
          :checkedAll='checkedAll',
          :headerCheckboxChangeEvent='setCheckedAll',
          :sort='sort',
          :sortChangeEvent='changeSort',
          :academyDatas='academyDatas',
          :checkedAcademyIds='checkedAcademyIds',
          :checkboxChangeEvent='setCheckedAcademyIds',
          :deleteEvent='deleteEvent',
          :editEvent='openEditModal'
        )
          template(#academyNameHeader)
            slot(name='academyNameHeader')
          template(#academyCodeHeader)
            slot(name='academyCodeHeader')
          template(#updatedDateHeader)
            slot(name='updatedDateHeader')
          template(#editHeader)
            slot(name='editHeader')
          template(#popupRemoveText)
            slot(name='popupRemoveText')
          template(#popupEditText)
            slot(name='popupEditText')
        .academy-list__content__body__main__footer
          button-pagination.academy-list__content__body__main__footer__pager(
            :status='pagenationStatus',
            @click='pagenationEvent'
          )
  //- モーダル部
  modal-academy-edit.academy-list__modal(
    v-if='academyEditData',
    ref='modalAcademyEdit',
    :title='modalTitle',
    :academyNamePlaceholder='modalAcademyNamePlaceholder',
    :academyCodePlaceholder='modalAcademyCodePlaceholder',
    :academyEditData='academyEditData',
    :keepButtonEvent='modalKeepButtonEvent',
    :errorMessages='modalErrorMessages'
  )
    template(#academyNameLabel)
      slot(name='modalAcademyNameLabel')
    template(#academyCodeLabel)
      slot(name='modalAcademyCodeLabel')
    template(#academyCodeDisabledLabel)
      slot(name='modalAcademyCodeDisabledLabel')
    template(#keepText)
      slot(name='modalKeepText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import SearchAcademy from '@/components/organisms/manager/SearchAcademy.vue'
import ButtonIconCircle from '@/components/molecules/manager/ButtonIconCircle.vue'
import ButtonUpload from '@/components/molecules/manager/ButtonUpload.vue'
import AcademyListTable from '@/components/organisms/manager/AcademyListTable.vue'
import ButtonPagination from '@/components/molecules/manager/ButtonPagination.vue'
import ModalAcademyEdit from '@/components/organisms/manager/ModalAcademyEdit.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { AcademyListType, AcademyListSortType, AcademyEditType } from '@/models/academyListModel'
import { PaginationStatus } from '@/models/paginationModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { AcademyBranchTabSetting } from '@/const/TabLinkSettings'
import { SortSetting } from '@/const/SortSettings'

/**
 * 塾管理画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    SearchAcademy,
    ButtonIconCircle,
    ButtonUpload,
    AcademyListTable,
    ButtonPagination,
    ModalAcademyEdit,
  },
})
export default class AcademyList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // 新規登録用の情報設定イベント
  @Prop()
  setRegisterDataEvent!: Function

  // 見出しタブクリック時のイベント
  @Prop()
  tabHeadingEvent!: Function

  // 塾コードプレースホルダー
  @Prop()
  academyCodePlaceholder!: string

  // 塾名プレースホルダー
  @Prop()
  academyNamePlaceholder!: string

  // 検索ボタン押下時イベント
  @Prop()
  searchEvent!: Function

  // ダウンロードボタン押下時イベント
  @Prop()
  downloadEvent!: Function

  // アップロードボタン押下時イベント
  @Prop()
  uploadEvent!: Function

  // ソート情報
  @Prop()
  sort!: AcademyListSortType

  // 塾一覧情報
  @Prop()
  academyDatas!: AcademyListType[]

  // 削除ボタン押下時イベント
  @Prop()
  deleteEvent!: Function

  // 編集用の情報設定イベント
  @Prop()
  setEditDataEvent!: Function

  // ページネーションの状態
  @Prop()
  pagenationStatus!: PaginationStatus

  // ページネーションイベント
  @Prop()
  pagenationEvent!: Function

  // モーダルのタイトル
  @Prop()
  modalTitle!: string

  // 編集対象の塾情報
  @Prop()
  academyEditData!: AcademyEditType

  // モーダルの塾名プレースホルダー
  @Prop()
  modalAcademyNamePlaceholder!: string

  // モーダルの塾コードプレースホルダー
  @Prop()
  modalAcademyCodePlaceholder!: string

  // モーダルの保存ボタン押下時イベント
  @Prop()
  modalKeepButtonEvent!: Function

  // モーダルに表示するエラーメッセージ
  @Prop()
  modalErrorMessages!: string[]

  // モーダルref
  @Ref()
  modalAcademyEdit!: ModalAcademyEdit

  // === 選択値を保持する変数群
  // 塾コード
  public academyCode = ''
  // 塾名
  public academyName = ''
  // 全チェックフラグ
  public checkedAll = false
  // チェックされた塾ID
  public checkedAcademyIds: number[] = []

  // === 選択値をセットする関数群
  // 塾コードをセット
  private setAcademyCode(value: string) {
    this.academyCode = value
  }
  // 塾名をセット
  private setAcademyName(value: string) {
    this.academyName = value
  }
  // 全チェックフラグをセット
  private setCheckedAll(value: boolean) {
    this.checkedAll = value
  }
  // チェックされた塾IDをセット
  private setCheckedAcademyIds(value: number[]) {
    this.checkedAcademyIds = value
  }

  // ソート値を変更
  private changeSort(sortSetting: SortSetting, sortTarget: string) {
    const sort = this.sort
    sort[sortTarget] = sortSetting
    this.$emit('sort-changed', sort)
  }

  // 新規登録モーダルを開く
  private async openRegisterModal() {
    await this.setRegisterDataEvent()
    if (this.academyEditData) {
      this.modalAcademyEdit.show()
    }
  }

  // 編集モーダルを開く
  private async openEditModal(id: number) {
    await this.setEditDataEvent(id)
    if (this.academyEditData) {
      this.modalAcademyEdit.show()
    }
  }

  // 見出しタブリンクの表示設定
  private get tabSetting(): AcademyBranchTabSetting {
    return AcademyBranchTabSetting
  }
}
</script>

<style lang="stylus" scoped>
.academy-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

      &__main
        z-index 1
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 0px 15px 15px 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__action
          display flex
          justify-content space-between
          align-items center
          padding 12px 20px

          &__search
            padding 7px 5px

          &__button
            display flex
            gap 12px

            &__icon
              width 32px
              height 32px

        &__footer
          display flex
          justify-content flex-end
          align-items center
          padding 20px 30px
          margin-top auto
</style>
